import type { PayloadAction } from "@reduxjs/toolkit";
import { NetworkType } from "Data/Objects/Network";
import { createAppSlice } from "Data/Redux/Store";
import type {
	NetworkIpSettingsState, NetworkIpv4Settings, NetworkIpv6Settings, ServicePortSettings
} from "Interfaces";

const placeholderIpv4Settings: NetworkIpv4Settings = {
	ipv4NetworkType: NetworkType.DHCP_AUTOMATIC_DNS,
	ipv4Address: "10.1.6.120",
	subnetMask: "255.255.255.0",
	ipv4Gateway: "10.1.6.1",
	dnsIpv4: [
		"10.1.3.23",
		"0.0.0.0"
	]
};

const placeholderIpv6Settings: NetworkIpv6Settings = {
	ipv6NetworkType: NetworkType.OFF,
	linkLocalAddress: "",
	ipv6Address: "",
	prefixLength: 0,
	ipv6Gateway: "",
	dnsIpv6: [ "", "" ]
};

const placeholderServicePortSettings: ServicePortSettings = {
	httpPort: 80,
	rtspPort: 554,
	httpsPort: 443
};

const initialState: NetworkIpSettingsState = {
	ipv4Settings: placeholderIpv4Settings,
	ipv6Settings: placeholderIpv6Settings,
	servicePortSettings: placeholderServicePortSettings
};

// #region reducers
export const setIpSettingsReducer = (
	state: NetworkIpSettingsState,
	action: PayloadAction<NetworkIpSettingsState>
) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

export const setDefaultIpSettingsReducer = (state: NetworkIpSettingsState) => {
	state.ipv4Settings.ipv4NetworkType = NetworkType.DHCP_AUTOMATIC_DNS;
};

// #endregion

// #region selectors
const getIpSettings = (state: NetworkIpSettingsState) => {
	return state;
};

// #endregion

const ipSettingsSlice = createAppSlice({
	name: "ipSettings",
	initialState,
	reducers: {
		setIpSettingsAction: setIpSettingsReducer,
		setDefaultIpSettingsAction: setDefaultIpSettingsReducer
	},
	selectors: {
		selectIpSettings: getIpSettings
	}
});

export default ipSettingsSlice;

export const { setIpSettingsAction, setDefaultIpSettingsAction } = ipSettingsSlice.actions;
export const { selectIpSettings } = ipSettingsSlice.selectors;
